import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import EditIcon from "../../../images/icons/EditIcon.svg";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import LockIcon from "@mui/icons-material/Lock";
import { BtnGroupStyle, DataGridListStyle } from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import { DialogPopup } from "../../../components/DialogPopup";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import { loadingAllAllergies } from "../../../Redux/Slice/AllergiesSlice";
import { v4 as uuid } from "uuid";
import {
  inactivateAndActivate,
  RemoveAllergy,
} from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import AddAllergies from "../../Allergies/AddAllergies";
import NoRecords from "../../../components/NoRecords";
import { TextNTooltip } from "../../../components/Content";
import EditAllergies from "../EditAllergies";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { useOnBehalfContext } from "../../../context/OnbehalfContext";
import { loadingPatientDetails } from "../../../Redux/Slice/PatientDetailsSlice";
import Tooltip from "@mui/material/Tooltip";

export default function AllergiesList(props: any) {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const { onBehalfContext }: any = useOnBehalfContext();

  const dispatch = useDispatch();
  const [rowData, setRowData] = useState({});
  const [deleteDataPopup, setDeleteDataPopup] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [addallergyPopup, setAddallergyPopup] = useState(false);
  const [editAllergyPopup, setEditAllergyPopup] = useState(false);
  const patientId: any = sessionStorage.getItem("patientId");
  const [selectionData, setSelectionData] = useState<any>({
    drugName: "",
    drugId: "",
  });

  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const navigate = useNavigate();

  const handleShowAddallergyPopupClick = () => {
    setAddallergyPopup(true);
  };
  const handleHideAddallergyPopupClick = () => {
    setAddallergyPopup(false);
  };
  const handleShowEditallergyPopupClick = () => {
    setEditAllergyPopup(true);
  };
  const handleHideEditallergyPopupClick = () => {
    setEditAllergyPopup(false);
  };
  const handleShowDeletePopupClick = () => {
    setDeleteDataPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteDataPopup(false);
  };

  const getInactivateAndActivate = async (row: any) => {
    try {
      const bodyData = {
        patientId: sessionStorage.getItem("patientId"),
        drugName: row?.drugName,
        drugId: row?.drugId,
        userDetails: {
          doctorId: localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await inactivateAndActivate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        getAllergiesData(page);
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: "Success!",
            variant: "success",
            open: true,
          };
        });
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const columnsAllergyInformation: GridColDef[] = [
    {
      field: "drugName",
      headerName: "Name",
      width: 150,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "reactions",
      headerName: "Reactions",
      width: 230,
      cellClassName: "w30",
      headerClassName: "w30",
      renderCell: (params: any) => (
        <TextNTooltip Text={params?.value?.join(", ")} />
      ),
    },
    {
      field: "onSetDate",
      headerName: "Onset Date",
      width: 120,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: (params: any) => <TextNTooltip Text={params?.value} />,
    },
    {
      field: "note",
      headerName: "Note",
      width: 200,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: (params: any) => <TextNTooltip Text={params?.value} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }) => {
        return (
          <>
            <Tooltip title="Edit">
              <IconButton
                color="primary"
                onClick={() => {
                  handleShowEditallergyPopupClick();
                  setRowData(row);
                }}
              >
                <img src={EditIcon} alt="Edit" loading="lazy" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                color="primary"
                className="trash"
                onClick={() => {
                  handleShowDeletePopupClick();
                  setSelectionData((prevState: any) => {
                    return {
                      ...prevState,
                      drugId: row?.drugId,
                      drugName: row?.drugName,
                    };
                  });
                }}
              >
                <img src={TrashIcon} alt="Delete" loading="lazy" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "allergyStatusFlag",
      headerName: "Status",
      width: 80,
      cellClassName: props.showStatus ? "w10" : " w10 hide",
      headerClassName: props.showStatus ? "w10" : " w10 hide",
      renderCell: ({ row }) => {
        return (
          <>
            {row?.allergyStatusFlag === "Active" ? (
              <YSButton
                onClick={() => {
                  getInactivateAndActivate(row);
                }}
                className="brightgreen"
                children={row?.allergyStatusFlag}
                size={"medium"}
                type="button"
                variant="contained"
              />
            ) : (
              <YSButton
                onClick={() => {
                  getInactivateAndActivate(row);
                }}
                className="grey"
                children={row?.allergyStatusFlag}
                size={"medium"}
                type="button"
                variant="contained"
              />
            )}
          </>
        );
      },
    },
  ];

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("drugId", selectionData.drugId);
      params.append("patientId", patientId);
      params.append("drugName", selectionData.drugName);
      const result = await RemoveAllergy(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getAllergiesData(page);
        dispatch(loadingPatientDetails());
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const AllergiesState = useSelector((state: any) => {
    return { ...state.AllergiesSlice };
  }); //redux data

  const [rowCountState, setRowCountState] = useState(
    AllergiesState?.Pagination?.totalItems || 0
  );

  const getAllergiesData = (nextPage: number) => {
    let paramdata = {
      pageNumber: nextPage,
      patientId: patientId,
    };
    dispatch(loadingAllAllergies(paramdata));
  };
  useEffect(() => {
    getAllergiesData(page);
  }, [page, patientId]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      AllergiesState?.Pagination?.totalItems !== undefined
        ? AllergiesState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [AllergiesState?.Pagination?.totalItems, setRowCountState]);

  return (
    <>
      <Grid
        container
        item
        xs={12}
        spacing={1}
        alignItems="top"
        justifyContent="center"
      >
        <Grid item xs={12}>
          <DataGridListStyle>
            <DataGrid
              rows={AllergiesState?.Items ?? []}
              headerHeight={36}
              sortingOrder={["desc", "asc"]}
              columns={columnsAllergyInformation}
              autoHeight
              rowHeight={40}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              getRowId={(row) => row.drugId ?? uuid()}
              loading={AllergiesState?.isLoading}
              components={{
                NoRowsOverlay: NoRecords,
                NoResultsOverlay: NoRecords,
                ErrorOverlay: ErrorOverlay,
              }}
              error={AllergiesState?.error || undefined}
              page={page}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              onPageChange={(newPage) => {
                setPage(newPage);
              }}
              rowCount={rowCountState}
            />
          </DataGridListStyle>
        </Grid>
        <Grid item xs={12}>
          <BtnGroupStyle className="middle">
            {props.showStatus ? (
              <>
                {" "}
                <YSButton
                  onClick={handleShowAddallergyPopupClick}
                  className=""
                  children={"Add New Allergy"}
                  size={"large"}
                  type="button"
                  color="primary"
                  variant="contained"
                  disabled={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id && UserServiceState?.profileGroup != 11
                      ? false
                      : UserServiceState?.profileGroup > 9
                      ? true
                      : false
                  }
                  startIcon={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id && UserServiceState?.profileGroup != 11
                      ? null
                      : UserServiceState?.profileGroup > 9 && <LockIcon />
                  }
                />{" "}
              </>
            ) : (
              <>
                {" "}
                <YSButton
                  onClick={() => {
                    navigate("/newrxpad");
                  }}
                  className=""
                  children={"Back to NewRx"}
                  size={"large"}
                  type="button"
                  color="primary"
                  variant="outlined"
                />{" "}
                <YSButton
                  onClick={handleShowAddallergyPopupClick}
                  className=""
                  children={"Add New Allergy Info"}
                  size={"large"}
                  type="button"
                  color="primary"
                  variant="contained"
                  disabled={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id && UserServiceState?.profileGroup != 11
                      ? false
                      : UserServiceState?.profileGroup > 9
                      ? true
                      : false
                  }
                  startIcon={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id && UserServiceState?.profileGroup != 11
                      ? null
                      : UserServiceState?.profileGroup > 9 && <LockIcon />
                  }
                />{" "}
              </>
            )}
          </BtnGroupStyle>
        </Grid>
      </Grid>{" "}
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <DialogPopup
        windowsize={"md"}
        show={addallergyPopup}
        handleShowPopupClick={handleShowAddallergyPopupClick}
        handleHidePopupClick={handleHideAddallergyPopupClick}
        title="Add New Allergy Info"
      >
        <AddAllergies
          addallergyPopup
          setAddallergyPopup
          handleShowPopupClick={handleShowAddallergyPopupClick}
          handleHidePopupClick={handleHideAddallergyPopupClick}
          getAllergiesData={getAllergiesData}
        />
      </DialogPopup>{" "}
      <DialogPopup
        windowsize={"md"}
        show={editAllergyPopup}
        handleShowPopupClick={handleShowEditallergyPopupClick}
        handleHidePopupClick={handleHideEditallergyPopupClick}
        title="Allergy Info"
      >
        <EditAllergies
          editAllergyPopup
          setEditAllergyPopup
          handleShowPopupClick={handleShowEditallergyPopupClick}
          handleHidePopupClick={handleHideEditallergyPopupClick}
          getAllergiesData={getAllergiesData}
          rowData={rowData}
        />
      </DialogPopup>{" "}
      <DialogPopup
        windowsize={"sm"}
        show={deleteDataPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
    </>
  );
}
